import { loginPhone, getUserInfo, adminLoginName, getAdminUserInfo, logoutDelete, loginByCode } from '@/api/modules/user.api.js';
import {
  USER_ROLE
} from '@/api/constants';
import authStorage from '@/utils/authStorage';
const TAB_ID = Math.random().toString(36).substr(2, 9)

export const user = {
  namespaced: true,

  state: () => ({
    // 认证信息
    auth: {
      access_token: null,
      role: 'guest0',
      email: null,
      name: null,
      permissions: [],
      sub: null,
      identifier: null,
      grant_type: null,
      scope: [],
      token_type: null,
      expires_in: null,
      client_id: null,
      authorities: []
    },

    // 业务信息
    profile: {
      location: "Romania",
      currency: "USD",
      language: null,
      preferences: {},
      avatar: null,
      phone: null,
      address: null
    },

    // 其他用户数据
    meta: {
      lastLogin: null,
      createdAt: null,
      updatedAt: null
    }
  }),

  mutations: {
    // 设置认证信息
    SET_AUTH(state, authData) {
      state.auth = {
        ...authData,  // 先使用新的数据
        // 确保 role 正确设置（如果 authorities 存在）
        role: authData.authorities ? authData.authorities[0] : (authData.role || 'guest3')
      };
    },

    // 设置用户资料
    SET_PROFILE(state, profileData) {
      state.profile = {
        ...state.profile,
        ...profileData
      };
    },

    // 设置所有用户信息
    SET_USER(state, userData) {
      state.profile = {
        ...state.profile,
        ...userData
      };
    },

    // SET_USER(state, userData) {
    //   if (userData.auth) {
    //     state.auth = {
    //       ...state.auth,
    //       ...userData.auth
    //     };
    //   }

    //   if (userData.profile) {
    //     state.profile = {
    //       ...state.profile,
    //       ...userData.profile
    //     };
    //   }
    // },

    // 清空用户信息
    CLEAR_USER(state) {
      state.auth = {
        access_token: null,
        role: 'guest',
        email: null,
        name: null,
        permissions: [],
        sub: null,
        identifier: null,
        grant_type: null,
        scope: [],
        token_type: null,
        expires_in: null,
        client_id: null,
        authorities: []
      };
      // 保留部分业务信息（如位置、货币等）
      //state.profile.location = state.profile.location || "Romania";
      //state.profile.currency = state.profile.currency || "USD";
    },

    // 更新位置
    SET_LOCATION(state, location) {
      state.profile.location = location;
    },

    // 更新货币
    SET_CURRENCY(state, currency) {
      state.profile.currency = currency;
    }
  },

  actions: {
    // 登录
    async login({ commit, dispatch }, credentials) {
      return new Promise((resolve) => {
        setTimeout(() => {
          // 根据邮箱判断角色
          const email = credentials.email || '';
          let role = 'customer';

          if (email.toLowerCase().includes('admin')) {
            role = 'admin';
          }

          const userData = {
            auth: {
              token: 'fake-jwt-token-' + Date.now(),
              role: role,
              email: email,
              name: credentials.name || email.split('@')[0],
              permissions: role === 'admin'
                ? ['dashboard', 'manage_users', 'manage_products']
                : ['view_products', 'create_orders']
            },
            profile: {
              location: "Romania", // 默认值
              currency: "USD" // 默认值
            }
          };

          console.log('Login successful:', userData);

          // 保存到 state
          commit('SET_USER', userData);

          // 持久化
          dispatch('persistUser');

          resolve(userData);
        }, 500);
      });
    },

    async loginByMobile({ commit, dispatch }, credentials) {
      const { phone, password } = credentials
      return loginPhone(phone, password).then(res => {
        authStorage.setToken(res.access_token)
        commit('SET_AUTH', res);
        return res
      }).catch(err => {
        throw err
      })


      return
      return new Promise((resolve) => {
        setTimeout(() => {
          // 根据邮箱判断角色
          const email = credentials.email || '';
          let role = 'customer';

          if (email.toLowerCase().includes('admin')) {
            role = 'admin';
          }

          const userData = {
            auth: {
              token: 'fake-jwt-token-' + Date.now(),
              role: role,
              email: email,
              name: credentials.name || email.split('@')[0],
              permissions: role === 'admin'
                ? ['dashboard', 'manage_users', 'manage_products']
                : ['view_products', 'create_orders']
            },
            profile: {
              location: "Romania", // 默认值
              currency: "USD" // 默认值
            }
          };

          console.log('Login successful:', userData);

          // 保存到 state
          commit('SET_USER', userData);

          // 持久化
          dispatch('persistUser');

          resolve(userData);
        }, 500);
      });
    },

    async handleLoginByCode({ commit, dispatch }, credentials) {
      const { phone, code } = credentials
      return loginByCode(phone, code).then(res => {
        authStorage.setToken(res.access_token)
        commit('SET_AUTH', res);
        return res
      }).catch(err => {
        throw err
      })
    },

    /**
     * webview 通过 URL 参数中的 token 进行登录（新增）
     */
    async loginByUrlToken({ commit, dispatch, state }, token) {
      if (!token) {
        throw new Error('Token is required')
      }

      try {
        authStorage.setToken(token)

        commit('SET_AUTH', {
          access_token: token
        })

        try {
          await dispatch('getCustomerInfo')
        } catch (error) {
        }
        try {
          // 调用 qualification 的 action 获取资格信息
          await dispatch('qualificationState/fetchQualification', null, { root: true })
          console.log('✅ 获取资格信息成功')
        } catch (error) {
          console.warn('⚠️ 获取资格信息失败:', error)
        }

        // 5. 升级 WebSocket 认证
        dispatch('upgradeAuth', token)

        // 6. 持久化
        dispatch('persistUser')
        return state.profile
      } catch (error) {
        console.error('❌ URL Token 登录失败:', error)
        dispatch('clearUserAndDegrade')
        throw error
      }
    },



    async adminLoginByUsername({ commit, dispatch }, credentials) {
      const { username, password } = credentials
      return adminLoginName(username, password).then(res => {
        authStorage.setToken(res.access_token)
        commit('SET_AUTH', res);
        dispatch('upgradeAuth', res.access_token)
        return res
      }).catch(err => {
        throw err
      })
    },

    async getCustomerInfo({ commit, dispatch }, credentials) {
      getUserInfo().then(res => {
        commit('SET_USER', res.data);
      }).catch(err => {})
    },

    async getAdminInfo({ commit, dispatch }, credentials) {
      getAdminUserInfo().then(res => {
        commit('SET_USER', res.data);
      })
    },

    async upgradeAuth({ commit, dispatch }, token) {
      dispatch(
        "websocket/send",
        {
          action: "upgrade_auth",
          payload: {
            messageId: `sub_${Date.now()}`,
            data: {
              token: token
            }
          }
        },
        { root: true }
      )
    },

    async degradeAuth({ commit, dispatch }) {
      dispatch(
        "websocket/send",
        {
          action: "degrade_auth",
          payload: {
            messageId: `sub_${Date.now()}`,
          }
        },
        { root: true }
      )
    },

    logout({ commit, dispatch }) {
      commit('CLEAR_USER');
      dispatch('degradeAuth');
      logoutDelete()
      localStorage.removeItem('user_data');
      localStorage.removeItem('user_role');
      authStorage.removeToken();
    },

    /**
    * webview 清除用户状态并降级订阅（新增）
    */
    clearUserAndDegrade({ commit, dispatch }) {
      commit('CLEAR_USER')
      dispatch('degradeAuth')
      authStorage.removeToken()
      localStorage.removeItem('user_data')
      localStorage.removeItem('user_role')
    },


    // 更新用户资料
    updateProfile({ commit, dispatch }, profileData) {
      commit('SET_PROFILE', profileData);
      dispatch('persistUser');
    },

    // 更新位置
    updateLocation({ commit, dispatch }, location) {
      commit('SET_LOCATION', location);
      dispatch('persistUser');
    },

    // 更新货币
    updateCurrency({ commit, dispatch }, currency) {
      commit('SET_CURRENCY', currency);
      dispatch('persistUser');
    },

    // 持久化用户数据
    persistUser({ state }) {
      console.log('persistUser')
      try {
        const userData = {
          auth: state.auth,
          profile: state.profile,
          meta: {
            lastPersist: new Date().toISOString()
          }
        };
        localStorage.setItem('user_data', JSON.stringify(userData));
        localStorage.setItem('user_role', state.auth.role);
      } catch (error) {
        console.error('Failed to persist user data:', error);
      }
    },

    // 从持久化存储恢复用户数据
    // restoreUser({ commit }) {
    //   try {
    //     const savedData = localStorage.getItem('user_data');
    //     if (savedData) {
    //       const userData = JSON.parse(savedData);
    //       commit('SET_USER', userData);
    //       console.log('User data restored from localStorage');
    //       return userData;
    //     }
    //   } catch (error) {
    //     console.error('Failed to restore user data:', error);
    //   }
    //   return null;
    // }
  },

  getters: {
    // 认证相关
    isAuthenticated: (state) => !!state.auth.access_token,
    userRole: (state) => state.auth.role,
    userName: (state) => state.auth.name,
    userEmail: (state) => state.auth.email,
    userToken: (state) => state.auth.access_token,

    // 业务相关
    userLocation: (state) => state.profile.location,
    userCurrency: (state) => state.profile.currency,
    userPreferences: (state) => state.profile.preferences,

    // 完整用户信息
    currentUser: (state) => ({
      ...state.auth,
      ...state.profile
    }),

    // 检查权限
    hasPermission: (state) => (permission) => {
      return state.auth.permissions.includes(permission);
    },

    // 检查角色
    isAdmin: (state) => state.auth.role === 'admin',
    isCustomer: (state) => state.auth.role === USER_ROLE.IDENTITY_CUSTOMER,
    isGuest: (state) => state.auth.role === 'guest'
  }
};